import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
@Component({
  selector: 'app-airports',
  templateUrl: './airports.component.html',
  styleUrls: ['./airports.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AirportsComponent {
  fileSelected:boolean=false
  selectedFile:any=null
    action:any
  airportRegFg!:FormGroup
  showAirportPopup:boolean=false
  airportData:any=[]
  columnsAirportsDisplay: string[] = ['name','iataCode','city','state','country'];
  expandedElement!: any | null;
  totalElements:any=0
  pageStr:any={
    number:'0',
    size:'10'
  }
  searchText:any=""

constructor(private fb : FormBuilder,private AirManagementService:AirManagementService,private toastMsgService : ToastmsgService){
this.sourceCodelist()
this.carrierCodelist()
  this.dataFields()
  this.AirportList()

}
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

  rowAirportClick(element:any){
    this.action="update"
    this.showAirportPopup=true

    this.airportRegFg=this.fb.group({
         "name":[element?.name,[Validators.required]],
      "city": [element?.city,[Validators.required]],
      "country":[element?.country,[Validators.required]],
      "state": [element?.state],
      "status": [element?.status],
      "iataCode":[element?.iataCode,[Validators.required]],
      "icaoCode":[element?.icaoCode],
      "latitude":[element?.latitude],
      "longitude":[element?.longitude],
      "elevation":[element?.elevation],
      "timeZoneOffset":[element?.timeZoneOffset],
      "timeZone":[element?.timeZone],
      
    });
  }


  closePopup(){
this.showAirportPopup=false
this.dataFields()
  }
  dataFields(){
  
    this.airportRegFg=this.fb.group({

      "name":['',[Validators.required]],
      "city": ['',[Validators.required]],
      "country":['',[Validators.required]],
      "state": [''],
      "status": ['A'],
      "iataCode":['',[Validators.required]],
      "icaoCode":[''],
      "latitude":[''],
      "longitude":[''],
      "elevation":[''],
      "timeZoneOffset":[''],
      "timeZone":[''],

      
    });
  }
  AddAirport() {
    this.AirManagementService.saveAirports(this.airportRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201 ||res.status==202) {
            this.toastMsgService.setMsg({msg : "Airport Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showAirportPopup=false
           this.AirportList()

          } else {
            const body : any = res.body;
            this.registerAirportErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerAirportErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerAirportErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Airport",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Airport",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  

  carrierCodeList:any=[]
  sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
carrierCodelist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

onAddAirport(){
  this.action="new"

  this.showAirportPopup=true
  this.dataFields()
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}

sourceName(item:any){
  if(item){
   let code:any=[]
   console.log(this.sourceCodeList)
   console.log(item)
   code =this.sourceCodeList.filter((items:any)=>items.code===item.toString())
   console.log(code)
   if(code.length>0){
    return code[0].title}
    else{
return item
    }
  }else{
    return item
  }

}

onFileSelected(event: any): void {
    
  this.fileSelected=true;


this.selectedFile = event.target.files[0] ?? null;

}

uploadFile(){
this.fileSelected=true;

this.AirManagementService
.UploadMiles(this.selectedFile)
.subscribe({
  next : (res:any) => {
    if(res) {

    this.fileSelected=false
    this.selectedFile=null
    this.showAirportPopup=false

      this.toastMsgService.setMsg({msg : "Upload File Successfully!",msgTitle : "Success", msgType : "I"});

    } else {
    
    } 
  },error : (err) => {
    this.toastMsgService.setMsg({msg : "Failed to Upload File",msgTitle : "Warning", msgType : "W"});


  }
}
)
}

searchFilter(){
  this.AirportList()
}

nextPage(event:PageEvent) {
    
  let page:any = {};
  this.pageStr['number'] = event.pageIndex.toString();
  this.pageStr['size'] = event.pageSize.toString();
  this.AirportList()
  //this.getAllUser(page)

}
AirportList(){

  this.AirManagementService
  .getAirportsList(this.pageStr,this.searchText)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res

     if(data.result.content.length>0){
      this.pageStr.number=data.result['number']
      this.pageStr.size=data.result['size']
    }
    this.totalElements = data.result['totalElements'];
    this.airportData=data.result['content']
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
}
